import { Float, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

@Entity()
export class ILSStatistics extends AdornisEntity {
  static override _class = 'ILSStatistics';

  @Field(type => Int, { default: v => v ?? 0 })
  availableExamSlots!: number;
  @Field(type => Int, { default: v => v ?? 0 })
  allocatedExamSlots!: number;
  @Field(type => Int, { default: v => v ?? 0 })
  bookings!: number;
  @Field(type => Int, { default: v => v ?? 0 })
  freeCancellations!: number;
  @Field(type => Int, { default: v => v ?? 0 })
  halfPriceCancellations!: number;
  @Field(type => Int, { default: v => v ?? 0 })
  lateCancellations!: number;
  @Field(type => Int, { default: v => v ?? 0 })
  noShows!: number;
  @Field(type => Float, { default: v => v ?? 0 })
  averageDaysToResult!: number;
  @Field(type => Float, { default: v => v ?? 0 })
  failureRate!: number;
}
